<script>
	import { getContext } from "svelte";
	import { tweened } from "svelte/motion";
	import { animationParameters } from "../constants";

	const { data, xGet, yGet, zGet, xScale, yScale, y } = getContext("LayerCake");

	export let hovered = null;

	export let opacity = 0.3;
	export let opacityHighlight = 1;
	export let highlight = () => false;
	export let highlightColor = () => false;

	function rnd(v) {
		return Math.round(v * 100) / 100;
	}

	/*
	const tPositionsX = tweened(positionsX, animationParameters);
	$: positionsX = $data.map((d, i) => rnd($xGet(d)));
  $: tPositionsX.set(positionsX);
  */
	$: positionsX = $data.map((d, i) => rnd($xGet(d)));

	$: positionsY = $data.map((d) => rnd($y(d) >= 0 ? $yGet(d) : $yScale(0)));
	const tPositionsY = tweened(positionsY, animationParameters);
	$: tPositionsY.set(positionsY);

	$: heights = $data.map((d) => rnd(($y(d) < 0 ? 1 : -1) * ($yGet(d) - $yScale(0))));
	const tHeights = tweened(heights, animationParameters);
	$: tHeights.set(heights);
</script>

<g class="bars-group">
	{#each $data as d, i}
		{@const h = highlight(d, i)}
		{@const hColor = highlightColor(d, i, $y(d))}
		<rect
			x={positionsX[i]}
			y={$tPositionsY[i]}
			width={$xScale.bandwidth()}
			height={$tHeights[i]}
			fill={h && hColor ? hColor : $zGet(d)}
			opacity={hovered ? (d === hovered ? opacityHighlight : opacity) : h ? opacityHighlight : opacity}
		/>
	{/each}
</g>

<style lang="scss">
	@import "../main.scss";
	// rect {
	// transition: fill $duration ease-in;
	// }
</style>
